import styled, { css } from 'styled-components';

export const Root = styled.div`
	display: flex;
	flex-direction: column;
`;

export const TitleH1 = styled.h1`
	${({ theme }) => theme.typography.headlineXXL};
	font-size: 48px;

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textAccentXL};
	}
`;

export const TitleH2 = styled.h2`
	margin-top: 0;
	margin-bottom: 32px;
	${({ theme }) => theme.typography.headlineXL};
	${({ isCenter }) => isCenter && 'text-align: center;'};

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.headlineS};
		text-transform: none;
		margin-bottom: 25px;
	} ;
`;

export const TitleH3 = styled.h3`
	${({ theme }) => theme.typography.headlineS};
	margin: 30px 0;
	${({ isCenter }) => isCenter && 'text-align: center;'};

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textAccentXS};
		margin: 0;
	}
`;

export const SubTitle = styled.h2`
	${({ theme }) => theme.typography.textL};
	width: 70%;

	@media (max-width: 1124px) {
		width: 100%;
	}

	@media (max-width: 600px) {
		${({ theme }) => theme.typography.textM};
	}
`;

export const IntroImageWrapper = styled.div`
	position: relative;
	width: 50vw;
	height: calc(45vw * 0.56);
	grid-area: img;
`;

export const StepTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	animation-fill-mode: both;

	@media (min-width: 701px) {
		align-items: center;
		text-align: center;
	}
`;

export const ContainerIntro = styled.div`
	display: grid;

	grid-template-rows: 1.2fr 0.8fr;
	grid-template-columns: 1.1fr 0.9fr;

	grid-template-areas: 'text img' 'btn img';

	column-gap: 15px;

	@media (max-width: 1620px) {
		grid-template-rows: 1fr 0.5fr;
	}

	@media (max-width: 1350px) {
		grid-template-rows: 1.2fr 0.3fr;
	}

	@media (max-width: 1180px) {
		grid-template-columns: 0.8fr 1fr;
	}

	@media (max-width: 1000px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}
`;

export const IntroBtnText = styled.span``;

const getSectionStyles = (type) => {
	switch (type) {
		case 'intro':
			return css`
				padding-bottom: 76px;
			`;
		case 'package':
			return css`
				padding: 0;
			`;
		case 'retail':
			return css`
				padding: 20px 0;
			`;
		case 'payment':
			return css`
				padding-bottom: 30px;
			`;
		case 'about':
			return css`
				padding: 40px;
				background: ${({ theme }) => theme.grayColor};
			`;
		case 'questions':
			return css`
				background: ${({ theme }) => theme.grayColor};
				padding: 80px 0;
				@media (max-width: 1280px) {
					padding-bottom: 90px;
				}
				@media (max-width: 640px) {
					padding-bottom: 60px;
					background: #ffffff;
				}
			`;
		default:
			return css``;
	}
};

export const Section = styled.section`
	position: relative;
	padding: 50px 0;
	overflow: hidden;
	${({ type }) => getSectionStyles(type)};

	@media (max-width: 600px) {
		padding: 30px 0;
	}
`;

export const LiraContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const PopupContentWrapper = styled.div`
	max-width: 480px;
	display: flex;
	flex-direction: column;
`;

export const ImageWrapper = styled.figure`
	grid-area: img;
	max-width: 100%;
	height: auto;
	padding: 0;
	margin: 0;
	position: relative;

	img {
		position: relative;
		z-index: 3;
	}

	&::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		z-index: 1;
		display: block;
		width: 35%;
		height: 0;
		padding-bottom: 35%;
		background: radial-gradient(50% 50% at 50% 50%, rgba(96, 236, 109, 0.7) 0%, rgba(221, 246, 224, 0.2) 100%);
		filter: blur(105.469px);
		transform: translate3d(25%, -30%, 0);
		border-radius: 50%;
	}

	&::after {
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 2;
		display: block;
		width: 75%;
		height: 0;
		padding-bottom: 75%;
		background: radial-gradient(50% 50% at 50% 50%, rgba(246, 81, 133, 0.7) 0%, rgba(238, 186, 203, 0) 100%);
		filter: blur(159.677px);
		transform: translate3d(-75%, -50%, 0);
		border-radius: 50%;
	}
`;

export const AdvantagesWrapper = styled.div`
	display: grid;
	grid-auto-flow: column;
	margin-top: 85px;
	gap: 10px;

	@media (max-width: 1124px) {
		margin-top: 30px;
	}

	@media (max-width: 805px) {
		margin: 20px -15px -10px;
		padding: 10px 15px;
		overflow-x: scroll;
	}
`;

export const AdElement = styled.div`
	display: grid;
	grid-template-columns: 48px 1fr;

	grid-template-areas: 'AdImg AdText';

	gap: 10px;
	background: ${({ bgColor }) => bgColor};

	width: 100%;
	padding: 16px;
	align-items: center;
	border-radius: 4px;
	box-sizing: border-box;

	${({ theme, isMobile }) => (isMobile ? theme.typography.textXS : theme.typography.textSemiBoldS)};

	@media (max-width: 1229px) {
		margin-bottom: 3px;
	}

	@media (max-width: 805px) {
		grid-template-columns: 32px 1fr;
		padding: 5px 16px;
		width: 230px;
		height: 100%;
	}
`;

export const StarIcon = styled.img`
	grid-area: AdImg;
	max-width: 100%;
	height: auto;
`;

export const ServicesBtnWrapper = styled.div`
	display: flex;
	justify-content: center;
`;

export const ServicesButton = styled.button`
	padding: 19px 70px;
	border: none;
	color: ${({ isActive, theme }) => (isActive ? theme.primaryColor : theme.darkGrayColor)};
	${({ theme }) => theme.typography.textAccentXS};
	background-color: transparent;
	cursor: pointer;
	border-bottom: ${({ isActive }) => (isActive ? `2px solid currentColor` : `2px solid transparent`)};

	@media (max-width: 600px) {
		padding: 0 50px 19px;
	}
`;

export const ServicesContent = styled.div`
	display: grid;
	grid-template-columns: repeat(${({ count }) => (count ? `${count}` : 3)}, 1fr);
	grid-gap: 20px;
	margin-top: 32px;

	@media (max-width: 1040px) {
		margin-left: -15px;
		margin-right: -15px;
		padding: 0 15px;
		overflow-x: scroll;
	}

	@media (max-width: 600px) {
		grid-template-columns: 1fr;
		grid-gap: 12px;
	}
`;

export const ServicesItem = styled.div`
	max-width: 600px;
	background: #ffffff;
	border: 2px solid ${({ theme }) => theme.lightGrayColor};
	box-sizing: border-box;
	border-radius: 4px;

	padding: 32px;
	margin-bottom: 3px;

	&:first-child {
		justify-self: end;
	}

	@media (max-width: 600px) {
		padding: 24px 16px;
		margin-bottom: 0;
	}
`;

export const ServicesWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const TextWrapper = styled.div`
	grid-area: text;
	margin-top: auto;
	margin-bottom: 70px;

	@media (max-width: 1000px) {
		margin-bottom: 6px;
	}
`;

export const IntroImage = styled.img`
	grid-area: img;
	max-width: 100%;
	height: auto;

	@media (max-width: 769px) {
		max-width: 80%;
	}

	@media (max-width: 425px) {
		max-width: 100%;
	}
`;
